import React, { Component } from 'react';
import ReactSelect from 'react-select';
import { connect } from 'react-redux';
import * as sideBarActions from '../../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../../redux/fabricCanvasActions';
import * as modalActions from '../../../../redux/modalActions';
import { bindActionCreators } from 'redux';
import { Icons } from '../../../../utilities';
import './Inspiration.scss';
import * as Constants from '../../../../utilities/constants/Constants';
import { string } from '../../../../localization';
import * as gaHelpers from '../../../../utilities/GAHelpers/GAHelpers';
import { getUnit } from '../../../../redux/homeActions';
import { convertImperialToGivenUnitSystem } from '../../../../utilities/HelperFunctions/HelperFunctions';

class Inspiration extends Component {
  state = { loadCounter: 0 };

  componentDidMount() {
    this.Masonry.addEventListener('scroll', e => this.trackScrolling(e));
  }

  componentDidUpdate(prevProps) {
    const { inspirations } = this.props;
    if (
      prevProps.inspirations.offset != inspirations.offset &&
      inspirations.offset == 0
    ) {
      this.setState({ loadCounter: 0 });
    }
  }

  componentWillUnmount() {
    this.Masonry.removeEventListener('scroll', e => this.trackScrolling(e));
  }

  trackScrolling = e => {
    const {
      moreImagesLoadingIndicator,
      maximumLimit,
      dispatchers
    } = this.props;

    if (
      this.Masonry.scrollTop + this.Masonry.clientHeight >=
      this.Masonry.scrollHeight
    ) {
      if (!moreImagesLoadingIndicator && !maximumLimit) {
        e.preventDefault();
        e.stopPropagation();
        this.loadMoreItems();
      } else {
        e.preventDefault();
        e.stopPropagation();
        this.Masonry.scrollTo(0, this.Masonry.scrollTop - 2);
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
      if (maximumLimit) {
        dispatchers.sideBarActions.setIsMaximumLimit(false);
      }
    }
  };

  shouldLoadNextInspirationList = () => {
    const innerMasonryViewHeight = document.getElementById('masonryView');
    const masonryContainerHeight = document.getElementById('masonry-list');
    let temp1 = 0;
    let temp2 = 0;
    if (innerMasonryViewHeight && masonryContainerHeight) {
      temp1 = innerMasonryViewHeight.clientHeight;
      temp2 = masonryContainerHeight.clientHeight;
      if (temp1 < temp2) {
        return true;
      }
    }
    return false;
  };

  checkForMoreInspirations = () => {
    const { dispatchers } = this.props;
    const shouldLoad = this.shouldLoadNextInspirationList();
    dispatchers.sideBarActions.setShouldLoadMoreContents(shouldLoad);
  };

  loadMoreItems = () => {
    const { dispatchers, inspirations } = this.props;

    if (dispatchers) {
      const currentPage = inspirations.offset + Constants.INSPIRATION_COUNT;
      dispatchers.sideBarActions.setShowLoading(true);
      dispatchers.sideBarActions.setInspirationOffset(
        currentPage,
        this.checkForMoreInspirations
      );
    }
  };

  checkForBlankAreaInInspiration = () => {
    const { shouldLoadMoreContents, dispatchers } = this.props;

    const innerMasonryViewHeight = document.getElementById('masonryView');
    const masonryContainerHeight = document.getElementById('masonry-list');
    let temp1 = 0;
    let temp2 = 0;
    if (innerMasonryViewHeight && masonryContainerHeight) {
      temp1 = innerMasonryViewHeight.clientHeight;
      temp2 = masonryContainerHeight.clientHeight;
      if (temp1 < temp2 && shouldLoadMoreContents) {
        this.loadMoreItems();
        dispatchers.sideBarActions.setShouldLoadMoreContents(false);
      }
    }
  };

  showInspirationSizeChangeWarning = (width, height) => {
    const {
      sizeChangeWarning,
      dispatchers,
      unitSystem,
      projectWidth,
      projectHeight
    } = this.props;
    const isInspirationSizeAndProjectSizeMatches =
      width == projectWidth && height == projectHeight;

    if (sizeChangeWarning && !isInspirationSizeAndProjectSizeMatches) {
      const dict = {
        header: string.INSPIRATION_SIZE_CHANGE_WARNING_TITLE,
        headerIcon: Icons.pixelation_warning_icon_black,
        description: (
          <div>
            {string.formatString(
              string.INSPIRATION_SIZE_CHANGE_WARNING,
              convertImperialToGivenUnitSystem(width, unitSystem),
              convertImperialToGivenUnitSystem(height, unitSystem),
              getUnit(unitSystem)
            )}
            <br />
            <br />
            {string.MODIFY_SIZE_WARNING}
          </div>
        ),
        stringColor: Constants.DEFAULT_STRING_COLOR,
        onclick: null,
        buttonTitles: {
          finish: string.OK_KEY,
          cancel: ''
        }
      };
      dispatchers.fabricCanvasActions.setMessageDialogParams(dict);
    }
  };

  handleImageLoaded = () => {
    const { loadCounter } = this.state;
    const updatedLoadCounter = loadCounter + 1;
    this.setState({ loadCounter: updatedLoadCounter });
    const { inspirations, dispatchers } = this.props;
    if (updatedLoadCounter === inspirations.portraitInspirations.length) {
      dispatchers.sideBarActions.setShouldLoadMoreContents(true);
    }
  };

  render() {
    const {
      inspirations,
      inspirationCategory,
      dispatchers,
      moreImagesLoadingIndicator,
      language
    } = this.props;

    const inspirationPreviewImages = inspirations.portraitInspirations;
    this.checkForBlankAreaInInspiration();
    let categoryArray = [];
    if (inspirationCategory !== []) {
      categoryArray = inspirationCategory.map(value => {
        const newDict = {};
        const languageDict = value.loc_names;

        newDict.value = value.category;
        newDict.label = languageDict && languageDict[language];
        return newDict;
      });

      const allDict = {};
      allDict.value = Constants.allInspirationCategory;
      allDict.label = string.ALL_TAB_TITLE_KEY;
      categoryArray.push(allDict);
    }

    const defaultSelectedCategory = categoryArray.filter(
      f => f.value === inspirations.category
    );

    const styleClass = moreImagesLoadingIndicator
      ? 'd-flex flex-column more-load-indicator-height-inspiration'
      : 'd-flex flex-column normal-height-inspiration';

    return (
      <>
        {/* Inspiration Tab */}
        <div className={styleClass}>
          <button
            type='button'
            style={{
              textAlign: 'right',
              border: 'none',
              background: 'none',
              outline: 'none'
            }}
            onClick={dispatchers.sideBarActions.clearDesign}
          >
            {/* Clear design  */}
            <img
              src={Icons.clearDesign}
              alt='clear design'
              style={{ cursor: 'pointer' }}
            />
            <label htmlFor='clearDesign' className='clear-design-label'>
              {string.CLEAR_DESIGN_KEY}
            </label>
          </button>
          <div
            style={{ marginBottom: '10px', width: '276px', marginLeft: '20px' }}
          >
            <img
              alt='arrow-theme'
              src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARAAAAAKCAYAAAB8MAFcAAABTElEQVRoQ+2YvUrEUBCFz2TBBf+w28Y3sFAbG61F1kYbNz8+XCq3SCMEiSiuQXsrX0Fj52LUVQyORAhso6QQHLgndQJnvjl83BuB8ScMw42yLG/TNH01HpXxSMA5AmJ54oMo2vQUZ6J6U1Uf20mSTCznZTYScI2AWYEEQbAF8U4BzNVLUcX1y/PTDk8irlWU81omYFIg0/KoxSGCNQALUB11uzO7cRy/WYbKbCTgCgFzAqn/eXxCLgWYhep5Udz3e73lFa+jVwAWa4mMx4/9LMveXVkS5yQBqwRMCeRbHooLEZlv5JHneVXDGwwOVykRqzViLlcJmBHIb/JolkOJuFpTzm2VgAmBtJEHJWK1QszlMoF/F8i0PFRx8lDc7TXXlp8Ww5OIy5Xl7JYISBBGaiKQ6vFweLTfNovv++vidUYAltp+w/dIgAT+lsAXZKqrGHMlWUoAAAAASUVORK5CYII='
            />
          </div>

          {/* Inspiration filter dropDown */}
          {inspirationCategory.length > 0 ? (
            <div style={{ marginLeft: '20px', width: '272px', height: '40px' }}>
              {/* check for array count */}
              <ReactSelect
                id='react-select-inspiration-dropdown'
                value={defaultSelectedCategory}
                options={categoryArray}
                onChange={e =>
                  dispatchers.sideBarActions.loadInspirations(
                    Constants.INSPIRATION_COUNT,
                    e,
                    () => {}
                  )
                }
                styles={{
                  control: base => ({
                    ...base,
                    '&:hover': { borderColor: 'gray' },
                    border: '1px solid rgb(128, 128, 128)',
                    borderRadius: '0px',
                    boxShadow: 'none',
                    background: 'none',
                    color: '#000',
                    cursor: 'pointer'
                  }),
                  option: provided => ({
                    ...provided,
                    color: '#000',
                    padding: '2px',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '12px'
                  }),
                  singleValue: base => ({
                    ...base,
                    color: 'white',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '12px'
                  }),
                  width: '272px'
                }}
              />
            </div>
          ) : null}

          {/* MasonryView */}
          <div className='flex-grow-1 content-template'>
            <div
              className='theme-wrapper masonry-container'
              ref={ref => {
                this.Masonry = ref;
              }}
              id='masonry-list'
            >
              <Masonry>
                {inspirationPreviewImages.map(data => (
                  <Tile
                    key={data.previewImage}
                    src={data}
                    handleImageLoaded={this.handleImageLoaded}
                    onSelect={[
                      this.showInspirationSizeChangeWarning,
                      dispatchers.fabricCanvasActions.loadInspiration
                    ]}
                  />
                ))}
              </Masonry>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const Tile = ({ src, onSelect, handleImageLoaded }) => (
  <div className='tile' key={src.previewImage}>
    <button
      style={{ border: 'none', background: 'none', outline: 'none' }}
      type='button'
      onClick={() => {
        onSelect[0](src.dataJSON.width, src.dataJSON.height);
        onSelect[1](src);
      }}
    >
      <img src={src.previewImage} onLoad={handleImageLoaded} alt='...' />
    </button>
  </div>
);

class Masonry extends React.Component {
  mapChildren = () => {
    const { children } = this.props;
    const col = [];
    const numberOfColumn = 2;
    for (let i = 0; i < numberOfColumn; i++) {
      col.push([]);
    }
    return children
      ? children.reduce((p, c, i) => {
          p[i % numberOfColumn].push(c);
          return p;
        }, col)
      : [];
  };

  getInspirationArrayKey = (type, index) => `${type}${index}`;

  render() {
    const children = this.mapChildren();
    return (
      <div className='masonry' id='masonryView'>
        {children.map((col, ci) => (
          <div
            className='column'
            key={this.getInspirationArrayKey('column', ci)}
          >
            {col.map((child, i) => (
              <div key={this.getInspirationArrayKey('row', i)}>{child}</div>
            ))}
          </div>
        ))}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeTemplatesTab,
    language: state.home.language,
    inspirationCategory: state.sideBar.inspirationCategory,
    inspirations: state.sideBar.inspirations,
    shouldLoadMoreContents: state.sideBar.shouldLoadMoreContents,
    moreImagesLoadingIndicator: state.sideBar.showLoading,
    maximumLimit: state.sideBar.isMaximumLimit,
    sizeChangeWarning: state.modal.storeData.sizeChangeWarning,
    projectWidth: state.home.projectWidth,
    projectHeight: state.home.projectHeight,
    unitSystem: state.home.unitSystem
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      modalActions: bindActionCreators(modalActions, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Inspiration);
